import { useSelector } from "react-redux";
import { getUserRolesApi, setUserRoleApi } from "../redux-sagas/api/handler";
import { useCallback, useState } from "react";
import { State } from "../types/common/State";
import { getTranslation } from "../utils/getTranslation";
import { TFunction } from "i18next";

type userRoles = {
    id: string,
    name: string
}

export const useGetUserRoles = (t: TFunction) => {
    const [roles, setRoles] = useState<userRoles[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const userInfo = useSelector((state: State) => state.userInfo) ?? {};
    const userId = useSelector((state: State) => state.userInfo?.userId) ?? 0;

    const getUserRoles = useCallback(async () => {
        const response = await getUserRolesApi(userId);
        const userRoles = response.data.data.map((rol: any) => ({
            id: rol.roleId,
            name: getTranslation(rol.roleName, t)
        }));
        setRoles(userRoles);
    }, [userId]);

    const setUserRole = async(roleId: string) => {
        try {
            setIsLoading(true);
            const payload = {
                email: userInfo.email,
                firstname: userInfo.firstname,
                lastname: userInfo.lastname,
                roleId: roleId,
            }
            const response = await setUserRoleApi(payload, userId);
            if (response.status === 200) {
                window.location.href = `${window.location.origin}/`;
            }
            setIsLoading(false);
        }catch (err) {
            console.warn(err);
            setIsLoading(false);
        }
    }

    if (roles.length === 0 && userId) {
        getUserRoles();
    }

    return {
        roles,
        isLoading,
        getUserRoles,
        setUserRole
    }
}